import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const CodeListItem = props => {
    const { item } = props;
    return (_jsxs("div", { className: cx('item'), children: [_jsx(Label, { className: cx('code'), children: item.value }), _jsx(Label, { className: cx('description'), children: item.data })] }));
};
CodeListItem.propTypes = {
    item: PropTypes.object.isRequired,
};
export default CodeListItem;
//# sourceMappingURL=index.js.map